export const rules: string[] = [
  "There will be 5 questions.",
  "Each question will be of one mark.",
  "There will be four options provided.",
  "You have to select only one option.",
  "Score must be more than 60% to win.",
];
